import { ThunderDispatcher } from "../../core/thunder-dispatcher.js";
export const dispatch_onDeleteConflicts = new ThunderDispatcher('__onDeleteConflicts');
//# sourceMappingURL=notification-dispatchers.js.map